import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { differenceInDays } from 'date-fns';
import { computed } from 'vue';
import { declOfNum } from '@/shared/lib/utils/numberFormatters';
import { toDate } from '@/shared/lib/utils/toDate';
import DaysToDateOutput from './DaysToDateOutput.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DaysLeftOutput',
  props: {
    input: null,
    iconSize: {
      default: 24
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var remainsTitles = ['Остался', 'Осталось', 'Осталось'];
    var daysLeft = computed(function () {
      var untilDate = toDate(props.input);
      if (!untilDate) {
        return '';
      }
      var days = Math.abs(differenceInDays(untilDate, new Date()));
      return "".concat(declOfNum(days, remainsTitles), " ");
    });
    return {
      __sfc: true,
      props: props,
      remainsTitles: remainsTitles,
      daysLeft: daysLeft,
      SIcon: SIcon,
      DaysToDateOutput: DaysToDateOutput
    };
  }
});